'use client';

import { c as _c } from "react/compiler-runtime";
import type { PropsWithChildren } from 'react';
import { NonProjectDalProvider } from '@/contexts/nonProjectDalProvider';
import { useMpaInterceptHandler } from './useMpaInterceptHandler';

// Wires the MPA intercept handler — which needs `useWorkspace` — into the
// non-project DAL provider. Splitting this out keeps `nonProjectDalContext`
// independent of the dialog/UI layer (otherwise the DAL → MPA-dialog →
// useWorkspace → DAL import cycle returns).
export const NonProjectDalWithMpa = t0 => {
  const $ = _c(4);
  const {
    children,
    isAuthenticated
  } = t0;
  const mpaInterceptHandler = useMpaInterceptHandler();
  let t1;
  if ($[0] !== children || $[1] !== isAuthenticated || $[2] !== mpaInterceptHandler) {
    t1 = <NonProjectDalProvider mpaInterceptHandler={mpaInterceptHandler} isAuthenticated={isAuthenticated}>{children}</NonProjectDalProvider>;
    $[0] = children;
    $[1] = isAuthenticated;
    $[2] = mpaInterceptHandler;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
};